const EditOrDeleteQuickLink = (props) => <div className={'hover'}>
  <button className={'btn btn-default'} onClick={props.onEdit}>
    Edit
  </button>
  <button className={'btn btn-danger'} onClick={props.onDelete}>
    Delete
  </button>
</div>

export default EditOrDeleteQuickLink
